// extracted by mini-css-extract-plugin
module.exports = {"verticallyCenter":"verticallyCenter--4-ENnFE8","horizontalCenter":"horizontalCenter--1b2EsrB6","mainDiv":"mainDiv--1gZ03Onv","image":"image--IF6RjXHe"};